import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import FieldLabel from "features/staff-tasks-v2/drawer/staff-task-card/field-label.component";
import type { StaffTask } from "services/types/staff-tasks.type";

import AddUserComment from "./add-user-comment.component";
import UserCommentInfo from "./user-comment-info.component";

type StaffTaskCommentsProps = {
  task: StaffTask;
  isBusy?: boolean;
};
export default function StaffTaskComments({
  task,
  isBusy
}: StaffTaskCommentsProps) {
  return (
    <Stack
      width="100%"
      sx={{
        maxHeight: "610px",
        overflow: "auto",
        boxSizing: "border-box",
        opacity: 0.85,
        "&:hover": {
          opacity: 1
        }
      }}
    >
      <Box ml={15}>
        <FieldLabel label="Comments" />
      </Box>

      {task.comments?.map((comment) => (
        <UserCommentInfo
          key={comment.id}
          taskId={task.id}
          comment={comment}
          isBusy={isBusy}
        />
      ))}
      <AddUserComment taskId={task.id} isBusy={isBusy} />
    </Stack>
  );
}
